import { _ } from 'numeral';
import useGraphQLClient from './graphqlClient';
import {
  Series,
} from './spotwrite';

class SeriesService {
  /**
   * ユーザIDを指定してTagを取得
   * @param userId
   * @returns
   */
  public getByUserId = async (userId: number) => {
    const client = useGraphQLClient();
    try {
      const exist = await client.findManySeries({
        where: { userId: { equals: userId } },
      });
      return exist.findManySeries as Series[];
    } catch (error) {
      console.log(error);
    }
    return [];
  }

  /**
   * タイトルとユーザIDを指定してSeriesを取得
   * @param title
   * @param userId
   * @returns
   */
  public getByTitle = async (title: string, userId: number) => {
    const client = useGraphQLClient();
    try {
      const exist = await client.findFirstSeries({
        where: {
          AND: [
            { userId: { equals: userId } },
            { title: { equals: title } },
          ],
        },
      });
      return exist.findFirstSeries;
    } catch (error) {
      console.log(error);
    }
    return null;
  }

  /**
   * Seriesを登録します
   * @param data
   */
  public create = async (data: any) => {
    if (!data.title || !data.userId) return null;
    const client = useGraphQLClient();

    const existSeries = await this.getByTitle(data.title, data.userId);
    // すでに存在する場合は、既存のデータを返却
    if (existSeries) return existSeries;
    try {
      // 新規作成
      const res = await client.createOneSeries({
        data: {
          title: data.title,
          user: {
            connect: { id: data.userId },
          },
        },
      });
      return res.createOneSeries as Series;
    } catch (error) {
      console.log(error);
    }
    return null;
  }
}
export default new SeriesService();
